import { Directive, Input, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  standalone: false,
    selector: '[appDisableControl]'
})
export class DisableControlDirective implements OnInit {
    private condition: boolean;

    @Input('appDisableControl') set disableControl(condition: boolean) {
        this.condition = condition;
        this.applyState();
    }

    constructor(private ngControl: NgControl) {
    }

    ngOnInit() {
        this.applyState();
    }

    private applyState() {
        if (!this.ngControl?.control) {
            return;
        }
        const action = this.condition ? 'disable' : 'enable';
        this.ngControl.control[action]();
    }
}
